export default __webpack_public_path__ + "static/media/mongodb.70c82e5a.png";